export const FAVORITES_STORAGE_KEY = 'games-tom-recent';

const MAX_FAVORITES = 32;

export function pickCartThumbnail(entry) {
  const img = entry?.images;
  if (img?.cart?.[0]?.publicPath) return img.cart[0].publicPath;
  if (entry?.cartThumbnail) return entry.cartThumbnail;
  if (entry?.thumbnail) return entry.thumbnail;
  if (!img) return null;
  return (
    img.box?.publicPath ||
    img.boxLarge?.publicPath ||
    img.screen?.[0]?.publicPath ||
    null
  );
}

export function gameToFavorite(game) {
  return {
    id: game.id,
    title: game.title,
    filename: game.filename ?? null,
    url: game.url ?? null,
    ejsKey: game.ejsKey ?? null,
    thumbnail: game.thumbnail ?? null,
    cartThumbnail: game.cartThumbnail ?? pickCartThumbnail(game) ?? game.thumbnail ?? null,
    vaultId: game.vaultId ?? null,
    playedAt: new Date().toISOString(),
  };
}

export function loadFavoriteSnapshots() {
  try {
    const raw = localStorage.getItem(FAVORITES_STORAGE_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export function saveFavoriteSnapshots(list) {
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* ignore */
  }
}

export function addFavoriteSnapshot(game) {
  const snap = gameToFavorite(game);
  let list = loadFavoriteSnapshots().filter((f) => f.id !== snap.id);
  list.unshift(snap);
  if (list.length > MAX_FAVORITES) list = list.slice(0, MAX_FAVORITES);
  saveFavoriteSnapshots(list);
  return list;
}

/** Junta snapshots guardados com dados actuais da biblioteca. */
export function resolveFavoriteGames(stored, groups, searchTerm = '') {
  const q = (searchTerm || '').trim().toLowerCase();
  const byId = new Map();
  for (const group of groups) {
    for (const game of group.games) {
      byId.set(game.id, game);
    }
  }

  return stored
    .map((fav) => {
      const live = byId.get(fav.id);
      if (live) {
        return {
          ...fav,
          ...live,
          cartThumbnail: live.cartThumbnail || fav.cartThumbnail || live.thumbnail,
        };
      }
      return {
        ...fav,
        hasRom: !!fav.url,
        needsDownload: !fav.url,
        fromVault: !!fav.vaultId,
        unsupported: false,
      };
    })
    .filter((f) => !q || f.title?.toLowerCase().includes(q));
}
